import { currentContentConfig } from './handleCurrentContentConfig';

// The functions below add metadata to the head of the application
export const loadTitle = () => {
  const title = document.createElement('title');

  title.textContent = currentContentConfig.headData.title;
  document.head.prepend(title);
};

export const loadMetaData = () => {
  const meta = document.createElement('meta');

  meta.name = currentContentConfig.headData.meta.name;
  meta.content = currentContentConfig.headData.meta.content;

  document.head.prepend(meta);
};

export const loadManifest = () => {
  const currentGame = process.env.REACT_APP_PRODUCT_NAME;
  const manifestPath = `/manifest.${currentGame}.json`;

  const link = document.createElement('link');
  link.rel = 'manifest';
  link.href = manifestPath;

  document.head.prepend(link);
};

export const loadHeadData = () => {
  loadTitle();
  loadMetaData();
  loadManifest();
};
